import React from 'react'
import {
  A11yStatementLink as SharedA11yStatementLink,
  B2BPrivacyPolicyLink as SharedB2BPrivacyPolicyLink,
  B2BCookiesPolicyLink as SharedB2BCookiesPolicyLink,
  B2BTandCLink as SharedB2BTandCLink,
  B2BContactLink as SharedB2BContactLink
} from '../policy-links'
import { WhatsNewLink as SharedWhatsNewLink } from '../whats-new/whats-new-link'

const A11yStatementLink = () => (
  <SharedA11yStatementLink data-test='footer-a11y-statement-link' />
)

const B2BPrivacyPolicyLink = () => (
  <SharedB2BPrivacyPolicyLink data-test='footer-privacy-policy-link' />
)

const B2BCookiesPolicyLink = () => (
  <SharedB2BCookiesPolicyLink data-test='footer-cookies-policy-link' />
)

const B2BTandCLink = () => (
  <SharedB2BTandCLink data-test='footer-tandc-link' />
)

const B2BContactLink = () => (
  <SharedB2BContactLink data-test='footer-contact-link'>
    Contact Us
  </SharedB2BContactLink>
)

const WhatsNewLink = () => (
  <SharedWhatsNewLink data-test='footer-whats-new-link' />
)

export {
  A11yStatementLink,
  B2BPrivacyPolicyLink,
  B2BCookiesPolicyLink,
  B2BTandCLink,
  B2BContactLink,
  WhatsNewLink
}
